interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}

export default function QuantitySelector({
  value,
  onChange,
  min = 1,
  max = 99,
  disabled = false,
}: QuantitySelectorProps) {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className="quantity-selector inline-flex items-center border border-gray-300 rounded">
      <button
        type="button"
        onClick={handleDecrease}
        disabled={disabled || value <= min}
        className="decrease-btn px-3 py-1 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-l"
        aria-label="Decrease quantity"
      >
        -
      </button>
      <div className="quantity-display px-4 py-1 bg-white text-center min-w-10 hover:cursor-pointer">
        {value}
      </div>
      <button
        type="button"
        onClick={handleIncrease}
        disabled={disabled || value >= max}
        className="increase-btn px-3 py-1 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-r hover:cursor-pointer"
        aria-label="Increase quantity"
      >
        +
      </button>
    </div>
  );
}
